import { Box } from 'src/design/atoms/Box';
import { Divider } from 'src/design/atoms/Divider';
import { Grid } from 'src/design/atoms/Grid';
import React from 'react';
import { useDrop } from 'react-dnd';
import { RateRequestDto } from 'src/api/FiretrolApiClient';
import { DragTypes } from './RateSheetCard/DragTypes';
import { ListItem } from './ListItem';

interface IItemsContainerProps {
  items: RateRequestDto[];
  onItemsChanged: (items: RateRequestDto[]) => void;
  showTotal?: boolean;
}
export const ItemsContainer: React.FC<IItemsContainerProps> = ({
  items,
  onItemsChanged,
  showTotal = false,
}) => {
  const [rates, setRates] = React.useState<RateRequestDto[]>(items);
  React.useEffect(() => {
    onItemsChanged(rates);
  }, [rates]);

  const [{ isOver }, drop] = useDrop({
    accept: [DragTypes.RATE],
    drop: (item: any) => {
      onDrop(item.data);
    },
    collect: (monitor: any) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  });

  const onDrop = (rate: RateRequestDto) => {
    const isThere = rates.find((r) => r.id === rate.id);
    if (!isThere) {
      setRates((prevRates) => {
        return [...prevRates, rate];
      });
    }
  };
  const onRemove = (rate: RateRequestDto) => {
    setRates((prevRates) => {
      return prevRates.filter((r) => r.id !== rate.id);
    });
  };

  const onQuanityChange = (rate: RateRequestDto, quantity: string) => {
    setRates((prevState) => {
      return prevState.map((r) => {
        if (r.id === rate.id) {
          return {
            ...r,
            quantity,
          };
        }
        return r;
      });
    });
  };
  const renderRates = (includeTotal = false) => {
    return rates.map((r) => {
      return (
        <ListItem
          key={r.id}
          rate={r}
          onRemove={() => onRemove(r)}
          onQuanityChange={(val) => onQuanityChange(r, val.quantity)}
          includeTotal={includeTotal}
        />
      );
    });
  };

  if (showTotal) {
    const total = rates.reduce((acc, rate) => {
      return acc + Number(rate.quantity) * Number(rate.rate1);
    }, 0);
    return (
      <Box
        ref={drop}
        role={DragTypes.CONTAINER}
        className={`item-container ${isOver && 'is-over'}`}
      >
        {rates.length > 0 && (
          <Box style={{ backgroundColor: '#fff', width: '100%' }}>
            <Grid style={{ backgroundColor: '#fff' }}>
              <Grid.Col span={3}>
                <h4>Item</h4>
              </Grid.Col>
              <Grid.Col span={3}>
                <h4>Qty</h4>
              </Grid.Col>
              <Grid.Col span={3}>
                <h4>Rate</h4>
              </Grid.Col>
              <Grid.Col span="auto" ta="right">
                <h4>Total</h4>
              </Grid.Col>
              <Grid.Col span="auto" />
            </Grid>
          </Box>
        )}

        {renderRates(true)}
        {rates.length > 0 && (
          <>
            <Divider my="sm" />
            <Grid>
              <Grid.Col span={3} />
              <Grid.Col span={3} />
              <Grid.Col span={3} />
              <Grid.Col span="auto" ta="right">
                ${total.toLocaleString()}
              </Grid.Col>
              <Grid.Col span="auto" />
            </Grid>
          </>
        )}

        {rates.length === 0 && (
          <Box ta="center" pt="xl">
            Drag & Drop Rates Here
          </Box>
        )}
      </Box>
    );
  }
  return (
    <Box
      ref={drop}
      role={DragTypes.CONTAINER}
      className={`item-container ${isOver && 'is-over'}`}
    >
      {rates.length > 0 && (
        <Box style={{ backgroundColor: '#fff', width: '100%' }}>
          <Grid style={{ backgroundColor: '#fff' }}>
            <Grid.Col span={5}>
              <h4>Item</h4>
            </Grid.Col>
            <Grid.Col span={5}>
              <h4>Qty</h4>
            </Grid.Col>
          </Grid>
        </Box>
      )}

      {renderRates()}
      {rates.length === 0 && (
        <Box ta="center" pt="xl">
          Drag & Drop Rates Here
        </Box>
      )}
    </Box>
  );
};
